module.exports = __webpack_public_path__ + "img/frameCardOne.e89559f4.png";